// jQuery
import "./vendor/jquery-import";

// Bootstrap Modules
// import { Collapse as Collapse } from 'bootstrap';
import "../../../node_modules/bootstrap/js/dist/collapse.js";
// import "../../../node_modules/bootstrap/js/dist/tooltip.js";
// import "../../../node_modules/bootstrap/js/dist/modal.js";

// import Rellax from "./vendor/parallax";

// import "./custom/videogif";

// Slider
import "../../../node_modules/@splidejs/splide/dist/js/splide"



// Fancybox
import { Fancybox } from "@fancyapps/ui";

// jQuery nice select
import "./vendor/jquery.nice-select";
// import Instafeed from "./vendor/instafeed.min";
import mixitup from "./vendor/mixitup";

import StackSlider from "./custom/stackSlider";

// Scroll animations
// import ScrollOut from 'scroll-out';

// import { initTranslate } from "./custom/translate";
import initSlider from "./custom/slider";
import initNav from "./custom/nav";
import { initHeader } from "./custom/header";
// import { initSlideCart } from "./custom/slide-cart";
// import { initMoveToTop } from "./custom/moveToTop";
// import { initGmap, gmapStylesInit } from "./custom/gmap"
import { loadGmapScript } from "./custom/InteractiveMap"

// import initForms from "./custom/forms";

import smoothscroll from 'smoothscroll-polyfill';
import { CountUp } from './custom/countUp';

// kick off the polyfill!
smoothscroll.polyfill();
// import enableFilterCollapse from "./custom/filters";

// console.log( Collapse );

// window.bootstrap = window.bootstrap || {};
// window.bootstrap.Collapse = Collapse;

window._atlas_ = window._atlas_ || { debug: true };

if (window._atlas_) {
    console.warn("DEBUGGIN MODE IS ON and on..");
} else {
    console.warn(window._atlas_);
}

const nbb_global = new (function () {
    const self = this;

    self.init = function () {
        console.log('TKC');
        let r = new StackSlider();
        // initHeader();
        initNav();
        self.nice_select();
        // initForms();
        // initMoveToTop();

        const collection = document.querySelectorAll('.count-up');

        let countUpSettings = {};
        let countUpArray = [];
        for (let i = 0; i < collection.length; i++) {
            
            countUpSettings.duration = 4;
            countUpSettings.scrollSpyDelay = 200;
            countUpSettings.enableScrollSpy = true;

            if( collection[i].hasAttribute('data-decimal') ) {
                countUpSettings.decimal = collection[i].dataset.decimal;
            }

            if( collection[i].hasAttribute('data-decimal-places') ) {
                countUpSettings.decimalPlaces = collection[i].dataset.decimalPlaces;
            }

            if( collection[i].hasAttribute('data-prefix') ) {
                countUpSettings.prefix = collection[i].dataset.prefix;
            }

            if( collection[i].hasAttribute('data-suffix') ) {
                countUpSettings.suffix = collection[i].dataset.suffix;
            }
            
            countUpArray.push(new CountUp(
                collection[i], 
                collection[i].dataset.countup,
                countUpSettings
                ));
                
            
            // if (!numAnim.error) {
            //     numAnim.start();
            // } else {
            //     console.error(numAnim.error);
            // }
        }

        // countUpArray.forEach((el) => el.start());

        var hamburger = document.querySelector(".hamburger");
        var header_nav = document.querySelector(".header__nav");
        var homepage = document.querySelector(".homepage");
        if( self.ifElementExists( hamburger ) ) {
            hamburger.addEventListener("click", function() {
                hamburger.classList.toggle("is-active");
                header_nav.classList.toggle("is-active");
                homepage.classList.toggle("fixed-position");
            });
        }

        var mobileSearchButton = document.getElementById("mobileSearchButton");
        var mobileSearcmobileSearchFieldhField = document.getElementsByClassName("header__topbar");
        if( self.ifElementExists( mobileSearchButton ) ) {
            mobileSearchButton.addEventListener("click", function() {
                if( self.ifElementExists( mobileSearcmobileSearchFieldhField ) ) {
                    mobileSearcmobileSearchFieldhField[0].classList.toggle("is-active");
                }
            });
        }

        loadGmapScript();
        initSlider();


        if( $('.teamMembers__mix').length ) {
            var mixer = mixitup('.teamMembers__mix');
            $(".teamFilter").on('change', 'select', function() {
                var sortBy = $("#sort-by").val();

                mixer.filter(`.${sortBy}`);
            });
        }


        // $('[data-fancybox]').fancybox({
        //     // Options will go here
        // });

        Fancybox.bind("[data-fancybox]", {
            // Your options go here
        });

        // copy clipboard
        self.copyToClipboard();

        // input fields effect
        $(".input-effect").val("");
		
		$(".input-effect input, .input-effect textarea").focusout(function(){
			if($(this).val() != ""){
				$(this).addClass("has-content");
			}else{
				$(this).removeClass("has-content");
			}
		})
    };

    self.copyToClipboard = function() {
        /* Get the text field */
        const copyText = document.querySelector(".copy-bio");
        if(self.ifElementExists(copyText)) {
            copyText.addEventListener(
                'click',
                (e) => {
                    e.preventDefault();
                    navigator.clipboard.writeText(window.location.href);
                }
            );
        }
    }

    // self.init_parallax = function() {
    //     var rellax = new Rellax('.rellax');
    // };

    self.ifElementExists = function(element) {
        if (typeof element != "undefined" && element != null) {
            return true;
        }
        return false;
    }

    self.nice_select = function () {
        $("select").niceSelect();
        // self.init_parallax();
    };

    $(() => {
        try {
            self.init();
        } catch (e) {
            console.warn("Error in global.js");
            console.log(e);
        }
    });
})();
